import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import AnnouncementBar from "@/components/AnnouncementBar";

export default function Layout({ children }) {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return (
    <>
      <div className="topbar-sticky">
        <AnnouncementBar />
        <Header />
      </div>
      <main>{children}</main>
      <Footer />
    </>
  );
}

export function PageHero({ crumb, title, subtitle }) {
  return (
    <section className="page-hero">
      <div className="wrap">
        {crumb && <div className="crumbs">{crumb}</div>}
        <h1>{title}</h1>
        {subtitle && <p>{subtitle}</p>}
      </div>
    </section>
  );
}
